"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseColumn = require("./support/BaseColumn");
var _Formatting = require("./support/Formatting");
var _AggregateFunctions = require("./support/AggregateFunctions");
var DateColumn = function DateColumn(_) {
  return null;
};
DateColumn.toColumnDef = function (child, intl) {
  var props = child.props;
  var accessorKey = props.accessorKey,
    formatOptions = props.formatOptions;
  var formatDate = function formatDate(value) {
    return intl.formatDate(value, formatOptions);
  };
  var defaultConfig = (0, _BaseColumn.defaultColumnDef)(props, formatDate);
  return _objectSpread({}, defaultConfig, {
    accessorKey: accessorKey,
    accessorFn: function accessorFn(originalRow) {
      var value = originalRow[accessorKey];
      return (0, _Formatting.dashMissingValue)(value) || formatDate(value);
    },
    sortingFn: function sortingFn(rowA, rowB) {
      var a = rowA.original[accessorKey];
      var b = rowB.original[accessorKey];
      return a > b ? 1 : a < b ? -1 : 0;
    },
    cell: function cell(cellProps) {
      var getValue = cellProps.getValue;
      var formattedValue = getValue();
      var cellValue = (0, _BaseColumn.getCellValue)(formattedValue, cellProps);
      return (0, _BaseColumn.styledCell)(props, cellValue);
    },
    aggregationFn: _AggregateFunctions.sum,
    footer: function footer() {
      var value;
      if (typeof props.footer === 'string') {
        value = props.footer;
      }
      if (value !== undefined) {
        return (0, _BaseColumn.styledCell)(props, value);
      }
      return null;
    }
  });
};
var _default = exports.default = DateColumn;